export default __webpack_public_path__ + "static/media/Icon21.506c0977.svg";